import styles from "./CategoryTile.module.css";

export default function CategoryTile({ label, icon, onClick }) {
  return (
    <button type="button" className={styles.tile} onClick={onClick}>
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      <span className={styles.label}>{label}</span>
    </button>
  );
}
